export const isTrackingDomain = () => {
  const host = window.location.host;
  return host.includes('tracking');
};

export const isPartnerDomain = () => {
  return !isTrackingDomain();
};
